import React from 'react';
import Contact from '../components/Contact';
import { usePageMeta } from '../hooks/usePageMeta';

/** Contact form and newsletter sign-up (route: /contact). */
const ContactPage: React.FC = () => {
  usePageMeta(
    'Contact | Pawsitive Future Foundation',
    'Get in touch with Pawsitive Future Foundation, or sign up for news about the pets your support helps.',
    '/contact'
  );
  return <Contact />;
};

export default ContactPage;
